import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import UserData from 'src/modules/user/types/user';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Component({
    selector: 'generate-user-password',
    templateUrl: './component.html',
    styleUrls: ['./component.scss'],
    standalone: false
})
export class GenerateUserPassword implements OnInit {
  public loading: boolean;
  public password;
  public name: string;

  constructor(
    protected dialogRef: MatDialogRef<GenerateUserPassword>,
    @Inject(MAT_DIALOG_DATA)
    private readonly data: UserData,
    private SnackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.name = `${this.data.User.first_name} ${this.data.User.last_name}`;
  }

  onGenerate() {
    const { dataSource } = this.data as UserData;
    this.loading = true;

    dataSource
      .updatePassword(this.data.User.id)
      .then((result) => (this.password = result.data.assignedPassword))
      .finally(() => (this.loading = false));
  }

  copyPassword() {
    navigator.clipboard.writeText(this.password);
    const config: MatSnackBarConfig = new MatSnackBarConfig();

    config.duration = 1000;
    config.panelClass = ['success'];

    this.SnackBar.open('Copied to clipboard', 'Close', config);
  }
}
